const STEP_DURATION = 4000;
const STEP_INTERSECTION_DURATION = 1000;

function loadImage(url) {
  return new Promise((resolve) => {
    const image = new Image();
    image.addEventListener('load', () => {
      resolve(image);
    });
    image.src = url;
  });
}

const init = async () => {
  const imagesBlock = document.querySelector('.js-morph-images');
  if (!imagesBlock) {
    return;
  }

  const imageWrappers = Array.from(imagesBlock.querySelectorAll('.js-morph-image'));
  if (!imageWrappers.length) {
    return;
  }

  await Promise.all(imageWrappers.map((imageWrapper) => loadImage(imageWrapper.querySelector('img').src)));

  const imagesSizes = imageWrappers.map((imageWrapper) => {
    const img = imageWrapper.querySelector('img');
    const width = img.offsetWidth;
    const height = img.offsetHeight;
    imageWrapper.style.width = `${width}px`;
    imageWrapper.style.height = `${height}px`;
    img.style.width = '100%';
    img.style.height = '100%';

    return {
      width,
      height,
    };
  });

  const getImageAnimation = (i) => {
    const imageWrapper = imageWrappers[i];
    const nextImageSize = imagesSizes[i + 1] || imagesSizes[0];
    const nextWidth = nextImageSize.width;
    const nextHeight = nextImageSize.height;

    return {
      imageWrapper,
      keyframes: [
        {
          opacity: 0,
        },
        {
          opacity: 1,
        },
        {
          width: `${imagesSizes[i].width}px`,
          height: `${imagesSizes[i].height}px`,
          opacity: 1,
        },
        {
          width: `${nextWidth}px`,
          height: `${nextHeight}px`,
          opacity: 0,
        },
      ],
      options: {
        duration: STEP_DURATION,
        iterations: 1,
      },
    };
  };

  const animateImages = async () => {
    function stepAnimate() {
      const animations = imageWrappers.map((imageWrapper, i) => getImageAnimation(i));

      animations.forEach((animation, i) => {
        const delay = i === 0 ? 0 : (i * STEP_DURATION) - (i * STEP_INTERSECTION_DURATION);
        setTimeout(() => {
          animation.imageWrapper.animate(animation.keyframes, animation.options);
        }, delay);
      });
    }

    stepAnimate();
    setInterval(stepAnimate, (imageWrappers.length * STEP_DURATION) - (imageWrappers.length * STEP_INTERSECTION_DURATION));
  };

  animateImages();
};

export default {
  init,
};
